import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { LoanChecklist } from '../loans/types';
import { checklistMockData } from '../utils/checklist.mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

interface TenantChecklistByIdResponse {
  success: boolean;
  checklistRule: LoanChecklist;
}

const _mockData = checklistMockData()[0];

const getTenantChecklistById: QueryFunction<
  LoanChecklist | null,
  ['/tenant/checklist', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<TenantChecklistByIdResponse>(
    '/checklist-rules/' + queryKey[1],
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data.checklistRule ?? null;

  throw new Error('Failed to fetch loan checklist');
};

export default getTenantChecklistById;
